import { cloneElement, type ReactElement } from "react";
import classNames from "classnames";
import MUITooltip from "@mui/material/Tooltip";
import type { TooltipProps } from "@mui/material/Tooltip";

import { useViewport } from "shared/contexts/ViewportContext";
import { TestProps } from "shared/types";

interface Props extends TooltipProps, TestProps {
  underline?: boolean;
}

const Tooltip = ({
  children,
  testId,
  underline,
  slotProps,
  ...otherProps
}: Props) => {
  const { isMobile } = useViewport();

  const child = underline
    ? cloneElement(children as ReactElement<{ className?: string }>, {
        className: classNames(
          (children as ReactElement<{ className?: string }>).props.className,
          "dotted-underline"
        ),
      })
    : children;

  return (
    <MUITooltip
      {...otherProps}
      slotProps={{
        ...slotProps,
        tooltip: {
          ...(slotProps?.tooltip ?? {}),
          "data-testid": testId,
        } as any,
      }}
      disableHoverListener={isMobile}
    >
      {child}
    </MUITooltip>
  );
};

export default Tooltip;
